<!--
@Time : 2020/11/28 7:27 下午
@Author : yekong
@File : xiyinli.vue
@Software : PhpStorm
-->
<template>
  <div>
    <titles title="投资吸引力"></titles>
    <div id="myChart6" :style="{width: '820px', height: '500px'}"></div>
  </div>
</template>

<script>
import titles from "@/components/title";

export default {
  name: "xiyinli",
  components: {titles},
  data: function () {
    return {}
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  created: function () {

  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart6'))
      // 绘制图表
      myChart.setOption({
            tooltip: {
              show: false,
              trigger: 'axis',
              borderWidth: 2,
              textStyle: {
                align: 'left'
              }
            },
            radar: {
              indicator: [{
                name: '大连',
                max: 9
              },
                {
                  name: '北京',
                  max: 9
                },
                {
                  name: '深圳',
                  max: 9
                },
                {
                  name: '上海',
                  max: 9
                }
              ],
              radius: '70%',
              center: ['50%', '50%'],
              shape: 'circle',
              splitNumber: 4,
              name: {
                formatter: function (name, indicator) {
                  indicator.value;
                  return '{a|' + name + '  }{b|' + indicator.max + '0' + '}'
                },
                rich: {
                  a: {
                    color: '#ffffff',
                    fontSize: 30
                  },
                  b: {
                    color: 'rgba(66, 192, 227, 1)',
                    fontSize: 30,
                    fontWeight: 700
                  }
                }
              },
              splitArea: {
                areaStyle: {
                  color: [
                    'rgba(255,255,255,0.1)',
                    'rgba(255,255,255,0)',
                    'rgba(255,255,255,0.1)',
                    'rgba(255,255,255,0)'
                  ]
                }
              },
              splitLine: {
                lineStyle: {
                  color: [
                    '#262f53', '#262f53',
                    '#121c44', '#121c44',
                    '#121c44', '#121c44'
                  ].reverse(),
                  width: 20
                }
              },
              axisLine: {
                lineStyle: {
                  color: 'rgba(238,238,238, 0.2)'
                }
              }
            },
            series: {
              name: '投资吸引力',
              type: 'radar',
              tooltip: {
                trigger: 'item'
              },
              data: [{
                value: [9, 9, 9, 8],
              }],
              symbol: 'circle',
              symbolSize: 12,
              itemStyle: {
                normal: {
                  color: 'rgba(87,201,255,0.8)',
                  borderColor: 'rgba(87,201,255,0.2)',
                  borderWidth: 12,
                }
              },
              areaStyle: {
                normal: {
                  color: 'rgba(13, 178, 255, 0.3)',
                }
              },
              lineStyle: {
                normal: {
                  color: 'rgba(13, 178, 255, 1)',
                  width: 5
                }
              },
            }
          }
      );
    }
  },
  mounted() {
    this.drawLine()
  },
}
</script>

<style lang="scss" scoped>

</style>
